export const APLICAR_TITLE = 'Aplicar';
export const TITULOS_ROTAS = ['Comparar Permissões'];
